<!--
 * @Descripttion: 
 * @Date: 2021-06-22 12:21:28
 * @LastEditors: Sima thief
 * @LastEditTime: 2021-06-24 10:55:21
 * @Author: Sima thief
-->
<template>
  <div class="page">
  
    <el-popover placement="right" trigger="click">
      <el-table size="mini" :data="tableData">
        <el-table-column label="中文品名">
          <template slot-scope="scope">
            {{scope.row.goodsnamec||''}}
          </template>
        </el-table-column>
        <el-table-column label="英文品名">
          <template slot-scope="scope">
            {{scope.row.goodsnamee||''}}
          </template>
        </el-table-column>
        <el-table-column label="商品类型">
          <template slot-scope="scope">
            {{scope.row.goods_type_id||''}}
          </template>
        </el-table-column>
        <el-table-column label="数量">
          <template slot-scope="scope">
            {{scope.row.piece||''}}
          </template>
        </el-table-column>
        <el-table-column label="型号">
          <template slot-scope="scope">
            {{scope.row.model||''}}
          </template>
        </el-table-column>
        <el-table-column label="品牌">
          <template slot-scope="scope">
            {{scope.row.brand||''}}
          </template>
        </el-table-column>
        <el-table-column label="货值">
          <template slot-scope="scope">
            {{scope.row.price||''}}
          </template>
        </el-table-column>
        <el-table-column label="海关编码">
          <template slot-scope="scope">
            {{scope.row.hs_code||''}}
          </template>
        </el-table-column>
        <el-table-column label="材质">
          <template slot-scope="scope">
            {{scope.row.materialc||''}}
          </template>
        </el-table-column>
        <el-table-column label="用途">
          <template slot-scope="scope">
            {{scope.row.purposec||''}}
          </template>
        </el-table-column>
        <el-table-column label="是否带电">
          <template slot-scope="scope">
            {{scope.row.is_has_battery||''}}
          </template>
        </el-table-column>
        <el-table-column label="是否带磁">
          <template slot-scope="scope">
            {{scope.row.is_has_magnetic||''}}
          </template>
        </el-table-column>
        <el-table-column label="是否液体/粉末">
          <template slot-scope="scope">
            {{scope.row.is_powder_liquid||''}}
          </template>
        </el-table-column>
        <el-table-column label="销售链接">
          <template slot-scope="scope">
            {{scope.row.sales_url||''}}
          </template>
        </el-table-column>
        <el-table-column label="产品图片"
                         width="90"
                         prop="">
          <template slot-scope="scope">
            <el-image class="table-goods-cover"
                      v-if="scope.row.picUrl"
                      :src="scope.row.picUrl"
                      :preview-src-list="[scope.row.picUrl]">
            </el-image>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="text" slot="reference">查看</el-button>
    </el-popover>
  </div>
</template>
  
 <script>
export default {
  name: "BoxPopover",
  props: {
    beforDetailOrderDTOs: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  mounted(){
    console.log('beforDetailOrderDTOs' , this.beforDetailOrderDTOs)
  },
  computed:{
    tableData(){
      if(!Array.isArray(this.beforDetailOrderDTOs)) return [];
      let list = JSON.parse(JSON.stringify(this.beforDetailOrderDTOs));
      list.forEach(res=>{
        for (let k in res){
         if(res[k] === 'null') res[k] = '';
        }
      });
      return list;
    }
  },
 
  
};
</script>

  
<style>
</style>



// WEBPACK FOOTER //
// src/components/mainOrders/components/BoxPopover.vue